import styled from 'styled-components'

export const ScrollableWrapper = styled.div`
  height: 100vh;
  overflow-y: auto;
  background: ${({ theme }) => theme.palette.grey[100]};
  padding: 32px 0;

  @media (max-width: 1024px) {
    padding: 16px 0;
  }
`

export const PageContainer = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 0 16px;
`

export const FullScreenCard = styled.div`
  max-width: 560px;
  margin: 48px auto;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
`

export const StepCard = styled.section`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`

export const StepIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  /* Optical centering: digits sit slightly high in the em box, so nudge them
     down. border-box keeps the padding from turning the circle into an oval —
     there is no global box-sizing reset in this app. */
  box-sizing: border-box;
  padding-top: 2px;
  border-radius: 50%;
  /* primary.main is the theme's silver (#eeeded), which reads as a disabled
     grey behind the white numeral. secondary.main is the accent blue. */
  background: ${({ theme }) => theme.palette.secondary.main};
  color: #fff;
  font-size: 16px;
  /* The inherited line-height leaves the glyph sitting low in the circle. */
  line-height: 1;
  font-weight: 600;
`

/* The asterisk that ./fields splits off a required field's label. */
export const RequiredMark = styled.span`
  color: ${({ theme }) => theme.palette.error.dark};
`

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 1024px) {
    flex-direction: column;
    /* Matches the margin-bottom above: once every field is full-width the
       desktop grouping is invisible, so keep one rhythm down the column. */
    gap: 16px;
  }
`

export const FieldWrapper = styled.div`
  flex: 1 1 ${({ $basis }) => $basis || '220px'};
  min-width: 0;

  /* The Row above stacks at this width, which turns the flex main axis
     vertical: the basis is a column width, but it would be read as a height
     and pad every field out to 220px. Fall back to the content height. */
  @media (max-width: 1024px) {
    flex: 0 0 auto;
  }
`

export const InfoBox = styled.div`
  background: ${({ theme }) => theme.palette.grey[50]};
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 14px;
`

/* Clinic-authored terms are typed into a textarea (settings/intake_forms#edit),
   so their newlines carry the paragraph breaks. Without pre-wrap they collapse
   into one wall of text. The settings preview already renders them this way. */
export const TermsBox = styled(InfoBox)`
  white-space: pre-wrap;
`

export const WarningBox = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`
